<template>
  <v-dialog
    v-model="dialog"
    :loading="loading"
    width="800"
  >
    <template #activator="{ attrs, on }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        small
      >
        Ansvar
      </v-btn>
    </template>

    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          Rediger typens ansvar
        </v-toolbar-title>

        <v-chip class="ml-3" label small>
          {{ deliveryType.title }}
        </v-chip>

        <v-spacer />

        <v-menu
          v-model="addMenu"
          offset-y
          left
          :min-width="800"
          :close-on-content-click="false"
        >
          <template #activator="{ attrs, on }">
            <v-btn small v-bind="attrs" v-on="on">
              Tilføj ansvar
              <v-icon right>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-toolbar flat>
              <v-toolbar-title>
                Tilføj ansvar
              </v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-autocomplete
                v-model="newResponsibility.id"
                :items="responsibilities"
                label="Vælg ansvar"
                outlined
                item-value="id"
                item-text="title"
                dense
              >
                <template #item="{ item, on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on" :disabled="items.map(x => x.responsibilityId).includes(item.id)">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.title }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
              <v-checkbox v-model="newResponsibility.required" label="Påkrævet" />
            </v-card-text>

            <v-card-actions>
              <v-spacer />

              <v-btn
                :loading="creating"
                @click="add"
              >
                Tilføj
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>

      </v-toolbar>
      <v-data-table
        :items="items"
        :headers="headers"
      >
        <template #[`item.required`]="{ value }">
          {{ value ? $t('common.yes') : $t('common.no') }}
        </template>
        <template #[`item.actions`]="{ item }">
          <v-btn small @click="remove(item.id)">
            <v-icon>
              mdi-delete-outline
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeliveryTypeResponsibilitiesComponent',
  props: {
    deliveryType: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      loading: true,
      loadingResponsibilities: false,
      creating: false,
      deleting: false,
      items: [],
      responsibilities: [],
      addMenu: false,
      newResponsibility: {},
      headers: [
        {
          text: 'Navn',
          value: 'responsibilityTitle'
        },
        {
          text: 'Påkrævet',
          value: 'required',
          align: 'right'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'right'
        }
      ]
    }
  },
  computed: {
    selectableResponsibilities() {
      return this.responsibilities.map(responsibility => {
        return {
          ...responsibility,
          disabled: this.responsibilities.some(rr => rr.responsibility.id === responsibility.id)
        }
      });
    }
  },
  methods: {
    getItems: async function() {
      this.loading = true;

      try {
        const { data } = await this.$api.get('delivery-type-responsibilities', {
          params: {
            deliveryTypeId: this.deliveryType.id
          }
        });

        this.items = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    getResponsibilities: async function() {
      this.loadingResponsibilities = true;

      try {
        const { data } = await this.$api.get('responsibilities', {
          params: {
            customerId: this.deliveryType.customerId
          }
        });

        this.responsibilities = data;
      } catch (error) {
        this.$notifier.showError({});
      } finally {
        this.loadingResponsibilities = false;
      }
    },
    add: async function() {
      this.creating = true;

      const model = {
        deliveryTypeId: this.deliveryType.id,
        responsibilityId: this.newResponsibility.id,
        required: this.newResponsibility.required
      };

      try {
        await this.$api.post('delivery-type-responsibilities', model);

        this.addMenu = false;
        this.newResponsibility = {};
        this.getItems();
        this.$notifier.showSuccess({});
      } catch (error) {
        console.error(error);
      } finally {
        this.creating = false;
      }
    },
    remove: async function(id) {
      if (!confirm('Er du sikker?')) return;

      this.deleting = true;

      try {
        await this.$api.delete('delivery-type-responsibilities/' + id);

        this.getItems();
        this.$notifier.showSuccess({});
      } catch (error) {
        console.error(error);
      } finally {
        this.deleting = false;
      }
    }
  },
  watch: {
    dialog(value) {
      if (value) {
        this.getItems();
      }
    },
    addMenu(value) {
      if (value && !this.responsibilities.length) {
        this.getResponsibilities();
      }
    }
  }
}
</script>